module.exports = __webpack_public_path__ + "landing_slider_fourth_slide_1067х800a.56d2eb6.jpg";